export enum RemoteConfigKey {
  Announcement = 'announcement',
}
export type RemoteConfig = {
  [RemoteConfigKey.Announcement]: {
    title?: string;
    description?: string;
    link?: string;
    targetChains?: number[];
  } | null;
};
export type RemoteConfigDataStructure =
  | 'string'
  | 'number'
  | 'boolean'
  | 'object';
